<div class="dialog-style">
  <h1 mat-dialog-title>{{ title }}</h1>
  <div mat-dialog-content style="width:300px" *ngIf='isHtmlContent' [innerHTML]='html'>
  </div>
  <div mat-dialog-content [innerHTML]="content" *ngIf='!isHtmlContent'>
    {{ content }}
  </div>

  <div mat-dialog-actions>
    <button mat-raised-button class='btn' mat-dialog-close>{{ closeButton }}</button>
  </div>
</div>